import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { Room } from '../../../../../models/hotel-room-types';
import { RoomInfoContent } from '../RoomInfoContent';
import Portal from 'sletat-ui-components2/dist/components/Portal';
import ModalWindow from 'sletat-ui-components2/dist/components/ModalWindow';

export interface RoomCardPopupProps {
  room: Room;
  closePopup: () => void;
}
interface StyledRoomCardPopupProps
    extends RoomCardPopupProps,
        JSSClassesProps<ComponentJSSClasses> {}

export const RoomCardPopup = ({
    room,
    classes,
    closePopup
}: StyledRoomCardPopupProps) => {

    return (
      <Portal>
        <ModalWindow
          isOpen={true}
          closeButtonSize="large"
          closeButtonVariant="success"
          modalBoxClassName={classes.popup}
          useLegacy={false}
          onClose={closePopup}
        >
          <RoomInfoContent room={room} />
        </ModalWindow>
    </Portal>
    );
};
